enum StatusDotType {
    GREEN = 'green',
    YELLOW = 'yellow',
    BLUE = 'blue',
    RED = 'red',
    GENERIC = 'generic',
}

export default StatusDotType;
